export default "__VITE_ASSET__BWMTcFpI__ 584w";